"use strict";

exports.__esModule = true;
exports.HistoricalDataItemChartV2Element = void 0;
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
var _react = _interopRequireWildcard(require("react"));
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _dataConverter = require("./dataConverter");
var _constants = require("../../constants");
var _Core = require("../../Core");
var _Time = require("../../Time");
var _Device = require("../../Device");
var _Charts = require("../../Charts");
var _dataItemChartOptions = require("../../Echarts/Series/dataItemChartOptions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var HistoricalDataItemChartV2Element = exports.HistoricalDataItemChartV2Element = function HistoricalDataItemChartV2Element(props) {
  var dataAccessor = (0, _react.useContext)(_DataAccessorContext.DataAccessorContext);
  var device = (0, _react.useContext)(_Device.DeviceContext);
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    uiModern = _useUiDesign.modern;
  var _useContext2 = (0, _react.useContext)(_Time.TimeContext),
    timezone = _useContext2.timezone;
  var timePeriod = (0, _Time.useSelectionContext)();
  var _props$dataItems = props.dataItems,
    dataItems = _props$dataItems === void 0 ? [] : _props$dataItems,
    widthForBin = props.widthForBin,
    options = props.options,
    downloadDataItemData = props.downloadDataItemData,
    width = props.width,
    height = props.height,
    targetValue = props.targetValue;
  var getBinSize = function getBinSize(interval, width) {
    var duration = interval.endMillis - interval.startMillis;
    var secondsPerPixel = Math.round(duration / (width * 1000)) * 2;
    return (secondsPerPixel >= 1 ? secondsPerPixel : 1) + "s";
  };
  var buildDeviceDataItemQuery = function buildDeviceDataItemQuery(deviceUuid, dataItemName, interval, width) {
    return {
      device: deviceUuid,
      dataItemName: dataItemName,
      binSize: getBinSize(interval, width),
      stats: ["avg"],
      start: new Date(interval.startMillis).toISOString(),
      end: new Date(interval.endMillis).toISOString(),
      category: _constants.CATEGORY_SAMPLE
    };
  };
  var load = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
      var interval, dataItems, device, widthForBin, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            interval = _ref.interval, dataItems = _ref.dataItems, device = _ref.device, widthForBin = _ref.widthForBin;
            if (!(!dataItems || dataItems.length === 0)) {
              _context.n = 1;
              break;
            }
            return _context.a(2, {});
          case 1:
            _context.n = 2;
            return Promise.all(dataItems.map(function (d) {
              return buildDeviceDataItemQuery(device.uuid, d.name, interval, widthForBin);
            }).map(function (q) {
              return dataAccessor.getRawConnectData(q);
            }));
          case 2:
            data = _context.v;
            return _context.a(2, (0, _dataConverter.convertDataToEchartsFormat)(data, device.name, dataItems));
        }
      }, _callee);
    }));
    return function load(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!dataItems || dataItems.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "HistoricalDataItemChartV2Element.chart"
    });
  }
  var asyncLoaderParams = {
    interval: timePeriod.interval,
    dataItems: dataItems,
    device: device,
    widthForBin: widthForBin
  };
  return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
    load: load,
    params: asyncLoaderParams
  }, function (loaderProps) {
    return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (data) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "HistoricalDataItemChartV2Element.chart"
      }, (options == null ? void 0 : options.chartItems) && /*#__PURE__*/_react["default"].createElement(_Charts.ReactEChartsLineChart, {
        width: width,
        options: (0, _dataItemChartOptions.createDataItemEChartProps)({
          series: data,
          device: device,
          dataItems: dataItems,
          options: options,
          timezone: timezone,
          translate: translate,
          useZeroAsBase: false,
          downloadCSVData: function downloadCSVData(deviceName, data) {
            return downloadDataItemData(deviceName, data);
          },
          targetValue: targetValue,
          uiModern: uiModern
        }),
        height: height,
        timezone: timezone
      }));
    });
  });
};